import { prefetchFeatureFlags } from "@climatepartner/app-shell/feature-flags";
// eslint-disable-next-line no-restricted-imports -- InitMuiLicense has no subpath
import { InitMuiLicense } from "@climatepartner/components";
import { createRoot } from "react-dom/client";

import { RootProviders } from "./app/root-providers";
import { initIntendedRoute } from "./app/routes/intended-route";
import { Router } from "./app/routes/routes.main";
import { featureFlagsConfig } from "./shared/feature-flags/feature-flags-config";
import { blockChartMeasurementFromLocalize } from "./shared/lib/block-chart-measurement-from-localize";
import { initChunkLoadRecovery } from "./shared/lib/chunk-load-recovery";

// First statement, deliberately: the Frontegg SDK rewrites the URL to `/` once it has handled the
// OAuth callback, and nothing in the import graph above touches the URL at evaluation time, so this
// reads the real entry URL.
initIntendedRoute();

// Before React mounts, so a chunk that goes missing during startup is recovered by a reload rather
// than painting the error boundary (AIM-2776).
initChunkLoadRecovery();

prefetchFeatureFlags(featureFlagsConfig.sdkKey);

// Before React mounts, because app-shell loads Localize from inside the tree.
blockChartMeasurementFromLocalize();

InitMuiLicense(import.meta.env.VITE_MUI_LICENCE_KEY);

createRoot(document.getElementById("root")!).render(
  <RootProviders>
    <Router />
  </RootProviders>
);
